import axios from 'axios';
import { GET_COMMISSION_PAYMENTS, GET_SPECIFIC_COMMISSION_PAYMENT, ADD_COMMISSION_PAYMENT, EDIT_COMMISSION_PAYMENT, DELETE_COMMISSION_PAYMENT, COMMISSION_PAYMENTS_LOADING, CLEAR_COMMISSION_PAYMENTS, CLEAR_COMMISSION_PAYMENT_CARD } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { ICommission_payment, ICommission_bulletin } from '../../types/interfaces';

export const getCommission_payments = () => (dispatch: Function, getState: Function) => {
  dispatch({
    type: COMMISSION_PAYMENTS_LOADING
  });
  axios
    .get('/api/commissionpayments', tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_COMMISSION_PAYMENTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getCommission_paymentById = (id: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: COMMISSION_PAYMENTS_LOADING
  });
  axios
    .get('/api/commissionpayments/specific', {...tokenConfig(getState), params: {id}})
    .then(res =>
      dispatch({
        type: GET_SPECIFIC_COMMISSION_PAYMENT,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getCommission_paymentsByUser = (duration: any, comId: number, projectId: number | "ALL") => (dispatch: Function, getState: Function) => {
  dispatch({
    type: COMMISSION_PAYMENTS_LOADING
  });
  axios
    .get('/api/commissionpayments/byUser', {...tokenConfig(getState), params: {duration, comId, projectId}})
    .then(res =>
      dispatch({
        type: GET_COMMISSION_PAYMENTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const payCommissions = (lines: ICommission_bulletin[], comId: number, comment: string, userId: number | undefined, callback: Function, print: boolean) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/commissionpayments', {lines, comId, comment, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: ADD_COMMISSION_PAYMENT,
        payload: res.data
      })
      callback(res.data, print)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const deleteCommission_payment = (id: number) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/commissionpayments/${id}`, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: DELETE_COMMISSION_PAYMENT,
        payload: id
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const setCommission_paymentsLoading = () => {
  return {
    type: COMMISSION_PAYMENTS_LOADING
  };
};

export const clearCommission_payments = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_COMMISSION_PAYMENTS
  })
};

export const clearCardCommission_payment = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_COMMISSION_PAYMENT_CARD
  })
};